import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() sideBarToggle = new EventEmitter<boolean>();
  @Output() userLogout = new EventEmitter<boolean>();

  constructor(public auth: AuthService, public core: CoreService) { }

  ngOnInit(): void {
  }

  logout() {
    this.auth.logout();
    this.userLogout.emit(true);
  }

}
